export default "__VITE_ASSET__zb4rY_Ad__"